import React, { useState, useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from "react-tooltip"
import uniq from 'lodash/uniq'
import { MRoom, MFacility } from '../types'
import { SearchContext } from "../search/SearchContext"

import HotelRoomAmenitiesModal from '../modals/HotelRoomAmenitiesModal'
import { showSurcharge, isNotPriceApplicableUser } from '../helpers/userHelper'
import {
  getRoomName,
  isAllInclusiveRoom,
  getAllInclusiveVerbiageForRoom
} from '../helpers/hotelHelper'

import isEqual from 'lodash/isEqual'

const HotelRooms = ({
  title,
  rooms,
  room,
  amenities,
  setRoom,
  setRate,
  setRoomsTitle,
  selectedRate,
  setRoomAndRate,
  showPrice
}) => {

  useEffect(() => {
    ReactTooltip.rebuild()
  })
  const setRoomRate = (room, rate) => {
    if (setRoomAndRate) {
      setRoomAndRate(room, rate)
    } else {
      setRoom(room)
      setRate(rate)
    }
  }

  const { state } = useContext(SearchContext)

  const [roomAmenitiesOpen, setRoomAmenitiesOpen] = useState(false)
  const [roomAmenities, setRoomAmenities] = useState([])

  const isSelectedRoom = idx => isEqual(room, rooms[idx])

  const toggleRoomAmenities = (event, room) => {
    event.stopPropagation()
    if (roomAmenitiesOpen) {
      setRoomAmenities([])
      setRoomAmenitiesOpen(false)
    } else {
      setRoomAmenities(getAmenitiesForRoom(room))
      setRoomAmenitiesOpen(true)
    }
  }

  const getAmenitiesForRoom = (room) => {
    if (!amenities) return false
    let roomCode = room['code']
    if (Array.isArray(roomCode)) {
      if (uniq(roomCode).length > 1) {
        return false
      }
      roomCode = roomCode[0]
    }
    return amenities.filter((amenity) => amenity.facility_group_code == 60 && ((!amenity.room_code) || (amenity.room_code == roomCode)))
  }

  const _toggleModal = () => setRoomAmenitiesOpen(!roomAmenitiesOpen)

  const _isNonRefundable = (room) => room.rates[0].rateClass === 'NRF'

  const _renderAmount = (r) => {
    if (isNotPriceApplicableUser(state.user)) {
      return ''
    }
    if (showSurcharge(state)) {
      return r.surcharge ? `$+${r.surcharge}` : ''
    } else {
      return r.net ? `$${Math.ceil(r.net)}` : ''
    }
  }

  const renderRoom = (r, idx) => {
    let roomCode = r.code
    if (Array.isArray(roomCode)) {
      roomCode = r.code.join('-')
    }
    if (r.rates.length === 1) {
      return (
        <button
          className={`row room check-box ${
            isSelectedRoom(idx) ? ' selected' : ''
          }`}
          key={`room-${roomCode}-${idx}`}
          aria-label={`Select ${getRoomName(r.name)} room`}
          onClick={() => setRoomRate(r, 0)}
          >
          <span className="name">
            {getRoomName(r.name)}
            {
              (getAmenitiesForRoom(r).length > 0) &&
              <i className="fas fa-info-circle view-amenity" onClick={(e) => toggleRoomAmenities(e, r)}></i>
            }
          </span>

          {showPrice && (
            <div className="price">
              {r.rates[0].showBoardCode ? (
                <div className="room-type" data-tip={r.rates[0].boardCodeMapping} data-html={true}>
                  {r.rates[0].boardCode}
                </div>) : <div />
              }
              <span>
                {_renderAmount(r.rates[0])}
                {_isNonRefundable(r) && "*"}
              </span>
            </div>
          )}
        </button>
      )
    }

    let rates = r.rates.map((rate, rateIdx) => {
      return (
        <button
          className={`row room check-box ${
            isSelectedRoom(r) && rateIdx == selectedRate ? ' selected' : ''
          }`}
          key={`room-${idx}-rate-${rateIdx}`}
          aria-label="Select rate"
          onClick={() => setRoomRate(r, rateIdx)}
          style={{ justifyContent: 'flex-end' }}
        >
          <div className="price">{_renderAmount(rate)}</div>
        </button>
      )
    })

    return (
      <div className="row room no-hover" style={{ display: 'block' }}>
        <span className="name">{getRoomName(r.name)}</span>
        {rates}
      </div>
    )
  }

  let items = rooms.map((r, i) => renderRoom(r, i))

  return (
    <div className="interactive rows rooms">
      {setRoomsTitle(title || 'Select Room', true,
                     !isNotPriceApplicableUser(state.user), !isNotPriceApplicableUser(state.user))}
      {items}
      <HotelRoomAmenitiesModal
        open        = {roomAmenitiesOpen}
        amenities   = {roomAmenities}
        toggleModal = {_toggleModal}
      />
    </div>
  )
}

HotelRooms.propTypes = {
  title: PropTypes.string,
  rooms: PropTypes.arrayOf(MRoom).isRequired,
  room: MRoom,
  amenities: PropTypes.arrayOf(MFacility),
  setRoom: PropTypes.func.isRequired,
  setRate: PropTypes.func.isRequired,
  setRoomsTitle: PropTypes.func.isRequired,
  selectedRate: PropTypes.number,
  setRoomAndRate: PropTypes.func,
  user: PropTypes.object,
  showPrice: PropTypes.bool
}

HotelRooms.defaultProps = {
  showPrice: true
}

export default HotelRooms
